/**
* 头部菜单
*/ 
<template>
  <div class="head-bar">
    <!-- <el-button class="buttonimg"  @click="toggle(collapsed)">
      <i v-if="collapsed" class="el-icon-s-fold"></i>
      <i v-else class="el-icon-s-unfold"></i>
    </el-button> -->
    <!-- <span style="margin-right: 15px">{{ user.username }}</span> -->
    <div class="nav-actions">
    <el-dropdown class="nav-dropdown" trigger="hover">
      <span class="nav-trigger">
        <span class="nav-name" :title="user.username">{{ user.username }}</span>
        <i class="nav-caret"></i>
      </span>
      <!-- <el-button type="primary" size="small">
        {{ user.username }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button> -->
      <!-- 切换账号面板：当前账号置顶灰底不可点，其余账号灰点可点 -->
      <el-dropdown-menu slot="dropdown" class="acct-menu">
        <li class="acct-header">切换账号</li>
        <li class="acct-current">
          <span class="acct-dot acct-dot-active"></span>
          <el-tooltip placement="left">
            <div slot="content">{{ user.username }}</div>
            <span class="truncate-text acct-current-name">{{ user.username }}</span>
          </el-tooltip>
          <i class="el-icon-check acct-check"></i>
        </li>
        <template v-if="userList && userList.length > 0">
          <el-dropdown-item
            v-for="(account, index) in userList"
            :key="index"
            @click.native="switchAccount(account)"
          >
            <span class="acct-dot"></span>
            <el-tooltip placement="left">
              <div slot="content">{{ account.username }}</div>
              <div class="acct-name-row">
                <span class="truncate-text acct-username">{{ account.username }}</span>
              </div>
            </el-tooltip>
          </el-dropdown-item>
        </template>
        <li v-else class="acct-empty">暂无可切换账号</li>
      </el-dropdown-menu>
    </el-dropdown>
    <span class="nav-split"></span>
    <el-dropdown class="nav-dropdown" trigger="hover">
      <span class="nav-trigger">
        个人中心
        <i class="nav-caret"></i>
      </span>
      <!-- 个人中心面板：菜单项带图标，退出红色隔离 -->
      <el-dropdown-menu slot="dropdown" class="menu-panel">
        <el-dropdown-item class="menu-item" @click.native="editPasswd()"
          ><i class="el-icon-key"></i>修改密码</el-dropdown-item
        >
        <el-dropdown-item v-if="roleId === 0" class="menu-item" @click.native="editMobile()"
          ><i class="el-icon-mobile-phone"></i>修改手机号</el-dropdown-item
        >
        <el-dropdown-item v-if="roleId === 3" class="menu-item" @click.native="showPaymentInfo()"
          ><i class="el-icon-money"></i>收款信息</el-dropdown-item
        >
        <li class="menu-divider"></li>
        <el-dropdown-item class="menu-item menu-exit" @click.native="exit()"
          ><i class="el-icon-switch-button"></i>退出登录</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
    </div>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="500px"
      custom-class="pwd-dialog"
      :before-close="handleClose"
    >
      <el-form
        :model="passwordForm"
        :rules="passwordRules"
        ref="passwordForm"
        label-width="100px"
      >
        <el-form-item label="密码类型">
          <el-radio-group v-model="passwordForm.passwordType" size="small">
            <el-radio-button label="login">登录密码</el-radio-button>
            <el-radio-button label="payment">支付密码</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            size="small"
            type="password"
            v-model="passwordForm.oldPassword"
            placeholder="请输入旧密码"
            show-password
          >
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            size="small"
            type="password"
            v-model="passwordForm.newPassword"
            placeholder="请输入新密码"
            show-password
          >
          </el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            size="small"
            type="password"
            v-model="passwordForm.confirmPassword"
            placeholder="请再次输入新密码"
            show-password
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onCancel">取 消</el-button>
        <el-button size="small" type="primary" @click="submitPassword"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="修改手机号"
      :visible.sync="mobileDialogVisible"
      width="560px"
      custom-class="mobile-dialog"
      :before-close="handleMobileClose"
    >
      <el-form
        :model="mobileForm"
        :rules="mobileFormRules"
        ref="mobileForm"
        label-width="100px"
      >
        <el-form-item label="当前手机号">
          <el-input size="small" :value="mobileMask" disabled></el-input>
        </el-form-item>
        <el-form-item label="原号验证码" prop="oldCode">
          <div class="sms-row">
            <el-input
              size="small"
              v-model="mobileForm.oldCode"
              placeholder="请输入原手机号验证码"
            >
            </el-input>
            <el-button
              size="small"
              :disabled="oldCountdown > 0"
              @click="sendOldMobileCode"
              >{{
                oldCountdown > 0 ? oldCountdown + "s后重发" : "获取验证码"
              }}</el-button
            >
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="verifyOldMobile"
            >验证原手机号</el-button
          >
          <p
            class="mobile-dialog-tip"
            :class="{ 'is-success': oldVerified }"
          >{{ mobileTip }}</p>
        </el-form-item>
        <el-form-item label="新手机号" prop="newMobile">
          <div class="sms-row">
            <el-input
              size="small"
              v-model="mobileForm.newMobile"
              placeholder="请输入新手机号"
              :disabled="!oldVerified"
            >
            </el-input>
            <el-button
              size="small"
              :disabled="!oldVerified || newCountdown > 0"
              @click="sendNewMobileCode"
              >{{
                newCountdown > 0 ? newCountdown + "s后重发" : "获取验证码"
              }}</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="新号验证码" prop="newCode">
          <el-input
            size="small"
            v-model="mobileForm.newCode"
            placeholder="请输入新手机号验证码"
            :disabled="!oldVerified"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="支付密码" prop="payPassword">
          <el-input
            size="small"
            type="password"
            v-model="mobileForm.payPassword"
            placeholder="请输入支付密码"
            :disabled="!oldVerified"
            show-password
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelMobileChange">取 消</el-button>
        <el-button size="small" type="primary" @click="submitMobileChange"
          >确认修改</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="收款信息" :visible.sync="payDialogVisible" width="500px">
      <el-form
        :model="payInfoForm"
        :rules="payInfoRules"
        ref="payInfoForm"
        label-width="100px"
      >
        <el-form-item label="收款方式：" prop="type">
          <el-radio-group v-model="payInfoForm.type">
            <el-radio label="1">个人</el-radio>
            <el-radio label="2">公司</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="payInfoForm.type == '2'">
          <el-form-item label="开票类型：" prop="invoiceType">
            <el-select
              v-model="payInfoForm.invoiceType"
              placeholder="请选择开票类型"
              clearable
              size="small"
              style="width: 90%"
            >
              <el-option
                v-for="item in invoiceTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="收款户名：" prop="payeeName">
          <el-input
            size="small"
            v-model="payInfoForm.payeeName"
            placeholder="请输入收款户名"
            style="width: 90%"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="收款账号：" prop="payeeAccount">
          <el-input
            size="small"
            v-model="payInfoForm.payeeAccount"
            placeholder="请输入收款账号"
            style="width: 90%"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="开户行：" prop="depositBank">
          <el-input
            size="small"
            v-model="payInfoForm.depositBank"
            placeholder="请输入开户行"
            style="width: 90%"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onCancelPay">取 消</el-button>
        <el-button size="small" type="primary" @click="submitPayInfo"
          >修 改</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  loginout,
  userPwd,
  getInfo,
  getSwitchAccount,
  getAllAccounts,
  getAgentUserInfo,
  updateAgentPayeeInfo,
  sendMobileChangeSms,
  verifyMobileChangeOld,
  confirmMobileChange,
} from "../api/userMG";
export default {
  name: "navcon",
  data() {
    return {
      invoiceTypeOptions: [
        { label: "专票1%", value: 1 },
        { label: "专票6%", value: 2 },
      ],
      roleId: "",
      agentInfo: {},
      userList: [],
      collapsed: true,
      imgshow: require("../assets/img/show.png"),
      imgsq: require("../assets/img/sq.png"),
      user: {},
      dialogVisible: false, // 控制修改密码对话框是否显示
      payDialogVisible: false,
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        passwordType: "login", // 新增，用于记录选择的密码类型，初始为登录密码
      },

      payInfoForm: {
        type: "",
        invoiceType: "",
        payeeName: "",
        payeeAccount: "",
        depositBank: "",
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 8, message: "新密码长度至少为8位", trigger: "blur" },
        ],
        confirmPassword: [
          {
            required: true,
            message: "请再次输入新密码",
            trigger: "blur",
          },
          {
            validator: this.validateConfirmPassword,
            trigger: "blur",
          },
        ],
      },
      payInfoRules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        payeeName: [
          { required: true, message: "请输入收款户名", trigger: "blur" },
        ],
        depositBank: [
          { required: true, message: "请输入开户行", trigger: "blur" },
        ],
        payeeAccount: [
          { required: true, message: "请输入收款账号", trigger: "blur" },
          { pattern: /^\d+$/, message: "收款账号必须为数字", trigger: "blur" },
        ],
      },
      // 修改手机号弹窗相关
      mobileDialogVisible: false,
      mobileMask: "",
      oldVerified: false,
      mobileTip: "请先验证原手机号，通过后可填写以下信息",
      oldCountdown: 0,
      newCountdown: 0,
      oldTimer: null,
      newTimer: null,
      mobileForm: {
        oldCode: "",
        newMobile: "",
        newCode: "",
        payPassword: "",
      },
      mobileFormRules: {
        oldCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
        newMobile: [
          { required: true, message: "请输入新手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "新手机号格式不正确",
            trigger: "blur",
          },
        ],
        newCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
        payPassword: [
          { required: true, message: "请输入支付密码", trigger: "blur" },
        ],
      },
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem("user_info"));
    this.roleId = this.user.roleId;
    // 商户才提供切换账号
    if (this.user && (this.user.roleId === 0 || this.user.roleId === 2)) {
      // 商户 风控
      this.getAllAccount();
    }
    // 代理商
    else if (this.user && this.user.roleId === 3) {
      this.getAgentInfo();
    }
  },
  methods: {
    getAgentInfo() {
      getAgentUserInfo().then((res) => {
        if (res.msg === "success") {
          this.agentInfo = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    switchAccount(user) {
      getSwitchAccount({ switchUserId: user.userId }).then((res) => {
        if (res.msg === "success") {
          localStorage.setItem("logintoken", res.data);
          // 切换账号成功后重新拉取完整登录态，保证本地缓存与登录时一致
          getInfo()
            .then((info) => {
              if (info.msg === "success") {
                localStorage.setItem("user_info", JSON.stringify(info.data));
                this.user = info.data;
              }
              // 切换账号成功后刷新页面
              window.location.reload();
            })
            .catch(() => {
              window.location.reload();
            });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getAllAccount() {
      getAllAccounts().then((res) => {
        if (res.msg === "success") {
          this.userList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onCancel() {
      // 重置表单验证状态
      this.$refs.passwordForm.resetFields();
      // 清空密码输入框的值
      this.passwordForm.oldPassword = "";
      this.passwordForm.newPassword = "";
      this.passwordForm.confirmPassword = "";
      this.passwordForm.passwordType = "login";
      this.dialogVisible = false;
    },
    handleClose() {
      // 重置表单验证状态
      this.$refs.passwordForm.resetFields();
      // 清空密码输入框的值
      this.passwordForm.oldPassword = "";
      this.passwordForm.newPassword = "";
      this.passwordForm.confirmPassword = "";
      this.passwordForm.passwordType = "login";
      this.dialogVisible = false;
    },

    onCancelPay() {
      this.payDialogVisible = false;
    },

    // 验证确认新密码是否与新密码一致
    validateConfirmPassword(rule, value, callback) {
      if (value === this.passwordForm.newPassword) {
        callback();
      } else {
        callback(new Error("两次输入的新密码不一致"));
      }
    },
    editPasswd() {
      this.dialogVisible = true;
      // 重置表单验证状态
      this.$refs.passwordForm.resetFields();
      // 清空密码输入框的值
      this.passwordForm.oldPassword = "";
      this.passwordForm.newPassword = "";
      this.passwordForm.confirmPassword = "";
      this.passwordForm.passwordType = "login";
    },
    submitPassword() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          const formData = new FormData();
          formData.append("userId", this.user.userId);
          formData.append("oldPassword", this.passwordForm.oldPassword);
          formData.append("newPassword", this.passwordForm.newPassword);
          formData.append("passwordType", this.passwordForm.passwordType);
          userPwd(formData)
            .then((res) => {
              if (res.msg === "success") {
                this.dialogVisible = false;
                this.$message({
                  type: "success",
                  message: "密码修改成功!",
                });
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error("密码修改失败，请稍后再试！");
            });
        }
      });
    },
    // 打开修改手机号弹窗并恢复初始锁定态
    editMobile() {
      this.resetMobileDialog();
      this.buildMobileMask();
      this.mobileDialogVisible = true;
    },
    // 当前认证手机号掩码（前3后4，空值兜底）
    buildMobileMask() {
      try {
        const cached = JSON.parse(localStorage.getItem("user_info"));
        const mobile = cached && cached.mobile ? String(cached.mobile).trim() : "";
        this.mobileMask =
          mobile.length >= 8
            ? mobile.slice(0, 3) + "****" + mobile.slice(-4)
            : "未绑定手机号";
      } catch (e) {
        this.mobileMask = "未绑定手机号";
      }
    },
    // 重置修改手机号弹窗全部本地态（倒计时/输入值/解锁标志）
    resetMobileDialog() {
      clearInterval(this.oldTimer);
      clearInterval(this.newTimer);
      this.oldTimer = null;
      this.newTimer = null;
      this.oldCountdown = 0;
      this.newCountdown = 0;
      this.oldVerified = false;
      this.mobileTip = "请先验证原手机号，通过后可填写以下信息";
      this.mobileForm.oldCode = "";
      this.mobileForm.newMobile = "";
      this.mobileForm.newCode = "";
      this.mobileForm.payPassword = "";
      this.$nextTick(() => {
        if (this.$refs.mobileForm) {
          this.$refs.mobileForm.resetFields();
        }
      });
    },
    handleMobileClose() {
      this.resetMobileDialog();
      this.mobileDialogVisible = false;
    },
    cancelMobileChange() {
      this.resetMobileDialog();
      this.mobileDialogVisible = false;
    },
    // 启动验证码按钮 60s 倒计时
    startMobileCountdown(type) {
      if (type === "old") {
        this.oldCountdown = 60;
        this.oldTimer = setInterval(() => {
          this.oldCountdown--;
          if (this.oldCountdown <= 0) {
            clearInterval(this.oldTimer);
          }
        }, 1000);
      } else {
        this.newCountdown = 60;
        this.newTimer = setInterval(() => {
          this.newCountdown--;
          if (this.newCountdown <= 0) {
            clearInterval(this.newTimer);
          }
        }, 1000);
      }
    },
    // 获取原手机号验证码
    sendOldMobileCode() {
      if (this.oldCountdown > 0) {
        return;
      }
      sendMobileChangeSms({ scene: "OLD" })
        .then((res) => {
          if (res.msg === "success") {
            this.$message.success("验证码已发送");
            this.startMobileCountdown("old");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("验证码发送失败，请稍后再试！");
        });
    },
    // 获取新手机号验证码（原号未验证通过前不可触达）
    sendNewMobileCode() {
      if (!this.oldVerified || this.newCountdown > 0) {
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.mobileForm.newMobile)) {
        this.$message.error("新手机号格式不正确");
        return;
      }
      sendMobileChangeSms({ scene: "NEW", newMobile: this.mobileForm.newMobile })
        .then((res) => {
          if (res.msg === "success") {
            this.$message.success("验证码已发送");
            this.startMobileCountdown("new");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("验证码发送失败，请稍后再试！");
        });
    },
    // 校验原手机号验证码，通过后解锁新号/新码/支付密码
    verifyOldMobile() {
      if (!this.mobileForm.oldCode) {
        this.$message.error("请输入短信验证码");
        return;
      }
      verifyMobileChangeOld({ code: this.mobileForm.oldCode })
        .then((res) => {
          if (res.msg === "success") {
            this.oldVerified = true;
            this.mobileTip = "原手机号验证通过，请填写以下新信息";
            this.$message.success("验证通过");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("验证失败，请稍后再试！");
        });
    },
    // 确认修改手机号
    submitMobileChange() {
      if (!this.oldVerified) {
        this.$message.error("请先验证原手机号");
        return;
      }
      this.$refs.mobileForm.validate((valid) => {
        if (valid) {
          confirmMobileChange({
            newMobile: this.mobileForm.newMobile,
            code: this.mobileForm.newCode,
            payPassword: this.mobileForm.payPassword,
          })
            .then((res) => {
              if (res.msg === "success") {
                this.$message({
                  type: "success",
                  message: "手机号修改成功!",
                });
                this.syncLocalMobileCache(this.mobileForm.newMobile);
                this.resetMobileDialog();
                this.mobileDialogVisible = false;
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error("手机号修改失败，请稍后再试！");
            });
        }
      });
    },
    // 改号成功后同步本地登录态缓存中的手机号
    syncLocalMobileCache(newMobile) {
      try {
        const cached = JSON.parse(localStorage.getItem("user_info"));
        if (cached) {
          cached.mobile = newMobile;
          localStorage.setItem("user_info", JSON.stringify(cached));
          this.user = cached;
        }
      } catch (e) {
        // 缓存异常不影响修改结果
      }
    },
    showPaymentInfo() {
      if (this.agentInfo == null) {
        this.$message.error("后台还未配置，请联系管理员配置代理商");
        return;
      }
      this.payDialogVisible = true;
      this.payInfoForm.type = String(this.agentInfo.type);
      this.payInfoForm.payeeName = this.agentInfo.payeeName;
      this.payInfoForm.payeeAccount = this.agentInfo.payeeAccount;
      this.payInfoForm.depositBank = this.agentInfo.depositBank;
      this.payInfoForm.invoiceType = this.agentInfo.invoiceType || "";
    },
    submitPayInfo() {
      if (this.payInfoForm.type != String(this.agentInfo.type)) {
        this.$confirm("更换收款方式会影响计算佣金方式, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$refs.payInfoForm.validate((valid) => {
              if (valid) {
                updateAgentPayeeInfo(this.payInfoForm)
                  .then((res) => {
                    if (res.msg === "success") {
                      this.onCancelPay();
                      this.getAgentInfo();
                      this.$message({
                        type: "success",
                        message: "修改成功!",
                      });
                    } else {
                      this.$message.error(res.msg);
                    }
                  })
                  .catch((err) => {
                    this.$message.error("修改失败，请稍后再试！");
                  });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$refs.payInfoForm.validate((valid) => {
          if (valid) {
            updateAgentPayeeInfo(this.payInfoForm)
              .then((res) => {
                if (res.msg === "success") {
                  this.onCancelPay();
                  this.getAgentInfo();
                  this.$message({
                    type: "success",
                    message: "修改成功!",
                  });
                } else {
                  this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                this.$message.error("修改失败，请稍后再试！");
              });
          }
        });
      }
    },
    // 退出登录
    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          loginout()
            .then((res) => {
              if (res.msg == "success") {
                //如果请求成功就让他2秒跳转路由
                setTimeout(() => {
                  localStorage.removeItem("logintoken");
                  localStorage.removeItem("user_info");
                  this.$router.push({ path: "/login" });
                  this.$message({
                    type: "success",
                    message: "已退出登录!",
                  });
                }, 1000);
              } else {
                this.$message.error(res.msg);
                this.logining = false;
                return false;
              }
            })
            .catch((err) => {
              localStorage.removeItem("logintoken");
              this.$router.push({ path: "/login" });
              this.logining = false;
              this.$message.error("退出失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    },
  },
};
</script>
<style scoped>
.head-bar {
  box-sizing: border-box;
  height: 60px;
  min-height: 60px;
  max-height: 60px;
  margin: 0;
  padding-right: 24px;
  background-color: #fff;
  color: #272727;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  box-shadow: 0px 4px 15px 0px rgba(92, 133, 168, 0.1);
}
.nav-actions {
  display: flex;
  align-items: center;
  height: 100%;
}
.nav-dropdown {
  cursor: pointer;
}
.nav-trigger {
  display: inline-flex;
  align-items: center;
  max-width: 280px;
  font-size: 14px;
  color: #606266;
  line-height: 22px;
}
.nav-trigger:hover {
  color: #303133;
}
.nav-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.nav-caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 6px;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid #c0c4cc;
  flex-shrink: 0;
}
.nav-trigger:hover .nav-caret {
  border-top-color: #909399;
}
.nav-split {
  width: 1px;
  height: 14px;
  margin: 0 16px;
  background: #dcdfe6;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.buttonimg i {
  font-size: 25px;
}

.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.el-dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
}
.truncate-text {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mobile-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}
/* 用户名下拉：切换账号分组样式 */
.acct-header {
  padding: 7px 14px;
  font-size: 12px;
  color: #909399;
  cursor: default;
}
.acct-current {
  display: flex;
  align-items: center;
  padding: 9px 14px;
  background-color: #f5f7fa;
  color: #303133;
  font-size: 13px;
  line-height: 20px;
  cursor: default;
}
.acct-current-name {
  color: #303133;
  font-size: 13px;
}
.acct-check {
  margin-left: auto;
  color: #409eff;
  font-weight: bold;
}
.acct-dot {
  flex: none;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #c0c4cc;
  margin-right: 10px;
}
.acct-dot-active {
  background-color: #409eff;
}
.acct-name-row {
  display: inline-flex;
  align-items: center;
  min-width: 0;
}
.acct-username {
  color: #606266;
  font-size: 13px;
}
.acct-empty {
  padding: 12px 14px;
  font-size: 12px;
  color: #909399;
  text-align: center;
  cursor: default;
}
.acct-menu .el-dropdown-menu__item {
  display: flex;
  align-items: center;
  padding: 9px 14px;
  line-height: 20px;
  color: #606266;
  font-size: 13px;
}
.acct-menu .el-dropdown-menu__item:hover {
  background-color: #f5f7fa;
  color: #606266;
}
/* 个人中心下拉：菜单图标 */
.menu-divider {
  height: 1px;
  background-color: #ebeef5;
  margin: 4px 0;
  cursor: default;
}
.menu-panel .el-dropdown-menu__item {
  padding: 9px 14px;
  line-height: 20px;
}
.menu-panel .el-dropdown-menu__item i {
  margin-right: 8px;
  color: #909399;
  font-size: 16px;
}
.menu-panel .el-dropdown-menu__item:hover {
  background-color: #f5f7fa;
  color: #606266;
}
.menu-panel .el-dropdown-menu__item:hover i {
  color: #909399;
}
.menu-panel .menu-exit,
.menu-panel .menu-exit i {
  color: #f56c6c;
}
.menu-panel .menu-exit:hover,
.menu-panel .menu-exit:hover i {
  background-color: #fef0f0;
  color: #f56c6c;
}
/* 弹窗公共：提示条/分区/分隔线/间距（贴脸紧凑版：文字与控件间距1~2px，大步骤间留白） */
.el-dialog__wrapper >>> .dlg-compact .el-dialog__header {
  padding: 2px 20px 0;
}
.el-dialog__wrapper >>> .dlg-compact .el-dialog__body {
  padding: 2px 20px 0;
}
.el-dialog__wrapper >>> .dlg-compact .el-dialog__footer {
  padding: 4px 20px 10px;
}
.dlg-form-mobile >>> .el-form-item__label {
  padding-bottom: 0 !important;
  font-size: 13px;
  line-height: 14px;
}
.dlg-form-mobile >>> .el-form-item__content {
  line-height: 32px !important;
}
.dlg-tip {
  background-color: #ecf5ff;
  color: #409eff;
  border-radius: 4px;
  padding: 2px 10px;
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 1px;
}
.dlg-divider {
  height: 1px;
  background-color: #ebeef5;
  margin: 8px 0;
}
.dlg-footer-line {
  height: 1px;
  background-color: #ebeef5;
  margin-top: 2px;
}
.dlg-form-mobile .el-form-item {
  margin-bottom: 14px !important;
}
</style>

<style>
.pwd-dialog {
  border-radius: 8px;
}
.pwd-dialog .el-dialog__header {
  padding: 16px 24px 4px !important;
}
.pwd-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  line-height: 24px;
}
.pwd-dialog .el-dialog__headerbtn {
  top: 16px;
  right: 20px;
}
.pwd-dialog .el-dialog__body {
  padding: 12px 24px 8px !important;
}
.pwd-dialog .el-dialog__footer {
  padding: 8px 24px 16px !important;
}
.pwd-dialog .el-form-item {
  margin-bottom: 20px !important;
}
.pwd-dialog .el-form-item:last-child {
  margin-bottom: 4px !important;
}
.pwd-dialog .el-form-item__label {
  color: #606266;
}
.pwd-dialog .el-radio-button__inner {
  padding: 8px 16px;
}
.mobile-dialog {
  border-radius: 8px;
}
.mobile-dialog .el-dialog__header {
  padding: 16px 24px 4px !important;
}
.mobile-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  line-height: 24px;
}
.mobile-dialog .el-dialog__headerbtn {
  top: 16px;
  right: 20px;
}
.mobile-dialog .el-dialog__body {
  padding: 8px 24px 8px !important;
}
.mobile-dialog .el-dialog__footer {
  padding: 8px 24px 16px !important;
}
.mobile-dialog-tip {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: #909399;
}
.mobile-dialog-tip.is-success {
  color: #67c23a;
}
.mobile-dialog .el-form-item {
  margin-bottom: 16px !important;
}
.mobile-dialog .el-form-item:last-child {
  margin-bottom: 4px !important;
}
.mobile-dialog .el-form-item__label {
  color: #606266;
}
.mobile-dialog .sms-row {
  display: flex;
  align-items: center;
}
.mobile-dialog .sms-row .el-input {
  flex: 1;
  margin-right: 8px;
}
.mobile-dialog .sms-row .el-button {
  flex-shrink: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue